export default "__VITE_ASSET__DHSdDzt7__"